import angular from 'angular';

import { sslCertificate } from './ssl-certificate';

export default angular.module('shbdeployer.settings.general', []).component('sslCertificateSettings', sslCertificate).name;
